import React, { Component } from "react";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import PrettyDropdown2 from "../../common/components/PrettyDropDown2";
import FiltersRow from "../../components/FiltersRow";
import HttpService from "../../Dashboard/duck/HttpService";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

const filterInputSx = {
  "& .MuiOutlinedInput-root": {
    height: "34px",
    backgroundColor: "#fff",
    borderRadius: 0,
    paddingRight: "4px",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    border: "none",
  },
  "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
    border: "none",
  },
  "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
    border: "none",
  },
  "& .MuiOutlinedInput-input": {
    padding: "7px 8px",
  },
};

class CachePageFilters extends Component {
  state = {
    locationOptions: [{ code: 0, description: "All" }],
    languageOptions: [{ code: 0, description: "All" }],
  };

  async componentDidMount() {
    const {
      locationOptions,
      languageOptions,
      useProvidedOptions = false,
    } = this.props;

    if (useProvidedOptions) {
      this.setState({
        locationOptions: locationOptions || [{ code: 0, description: "All" }],
        languageOptions: languageOptions || [{ code: 0, description: "All" }],
      });
      return;
    }

    try {
      const [locationsRes, languagesRes] = await Promise.all([
        HttpService.getLocationsList(),
        HttpService.getLanguageList(),
      ]);

      this.setState({
        locationOptions: [
          { code: 0, description: "All" },
          ...((locationsRes?.data?.data || locationsRes?.data || []).map((item) => ({
            code: item.id,
            description: item.description ?? item.name,
          }))),
        ],
        languageOptions: [
          { code: 0, description: "All" },
          ...((languagesRes?.data?.data || languagesRes?.data || []).map((item) => ({
            code: item.id,
            description: item.description ?? item.name,
          }))),
        ],
      });
    } catch (err) {
      console.error("Failed to load cache page filter options:", err);
      this.setState({
        locationOptions: [{ code: 0, description: "All" }],
        languageOptions: [{ code: 0, description: "All" }],
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.useProvidedOptions) {
      if (
        prevProps.locationOptions !== this.props.locationOptions ||
        prevProps.languageOptions !== this.props.languageOptions
      ) {
        this.setState({
          locationOptions: this.props.locationOptions || [{ code: 0, description: "All" }],
          languageOptions: this.props.languageOptions || [{ code: 0, description: "All" }],
        });
      }
    }
  }

  handleClearFilters = () => {
  const cleared = {
    location_id: null,
    language_id: null,
    approved: null,
    filter_used_count_min: null,
    filter_used_count_max: null,
    filter_created_from: null,
    filter_created_to: null,
    filter_published_from: null,
    filter_published_to: null,
    filter_last_used_from: null,
    filter_last_used_to: null,
  };

  this.emitChange(cleared);
};

  getDropdownValue = (value) => {
    if (value === null || value === undefined || value === "") return 0;
    return Number(value);
  };

  emitChange = (updates) => {
    if (this.props.onChange) {
      this.props.onChange(updates);
    }
  };

  handleLocationChange = (val) => {
    const selectedValue =
      val === 0 || val === "0" || val === null ? null : Number(val);

    if (this.props.onLocationChange) {
      this.props.onLocationChange(selectedValue);
      return;
    }

    this.emitChange({ location_id: selectedValue });
  };

  handleLanguageChange = (val) => {
    const selectedValue =
      val === 0 || val === "0" || val === null ? null : Number(val);

    if (this.props.onLanguageChange) {
      this.props.onLanguageChange(selectedValue);
      return;
    }

    this.emitChange({ language_id: selectedValue });
  };

  handleApprovedChange = (e) => {
    const value = e.target.value;

    const mappedApproved =
      value === "true"
        ? true
        : value === "false"
        ? false
        : null;

    if (this.props.onApprovedChange) {
      this.props.onApprovedChange(mappedApproved);
      return;
    }

    this.emitChange({ approved: mappedApproved });
  };

  parseDateValue = (value) => {
    if (!value) return null;
    const d = value instanceof Date ? value : new Date(value);
    return Number.isNaN(d.getTime()) ? null : d;
  };

  formatDateValue = (value) => {
    if (!value || Number.isNaN(value.getTime())) return null;

    const yyyy = value.getFullYear();
    const mm = String(value.getMonth() + 1).padStart(2, "0");
    const dd = String(value.getDate()).padStart(2, "0");

    return `${yyyy}-${mm}-${dd}`;
  };

  renderDateRange = (label, fromKey, toKey) => {
    const { filters = {} } = this.props;

    const fromValue = this.parseDateValue(filters?.[fromKey]);
    const toValue = this.parseDateValue(filters?.[toKey]);

    return (
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <div style={{ display: "flex", gap: 8, alignItems: "center", width: "100%" }}>
          <DatePicker
            label="From"
            value={fromValue}
            onChange={(value) => {
              this.emitChange({
                [fromKey]: this.formatDateValue(value),
              });
            }}
            slotProps={{
              textField: {
                size: "small",
                variant: "outlined",
                sx: {
                  ...filterInputSx,
                  minWidth: 150,
                },
              },
            }}
          />

          <DatePicker
            label="To"
            value={toValue}
            onChange={(value) => {
              this.emitChange({
                [toKey]: this.formatDateValue(value),
              });
            }}
            minDate={fromValue || undefined}
            slotProps={{
              textField: {
                size: "small",
                variant: "outlined",
                sx: {
                  ...filterInputSx,
                  minWidth: 150,
                },
              },
            }}
          />
        </div>
      </LocalizationProvider>
    );
  };

  render() {
    const {
      filters = {},
      locationValue,
      languageValue,
      approvedValue,
    } = this.props;

    const { locationOptions, languageOptions } = this.state;

    const resolvedLocationValue =
      locationValue !== undefined ? locationValue : filters?.location_id;

    const resolvedLanguageValue =
      languageValue !== undefined ? languageValue : filters?.language_id;

    const resolvedApprovedValue =
      approvedValue !== undefined ? approvedValue : filters?.approved;

    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 12,
          maxWidth: 1500,
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <div
            style={{
              fontSize: 13,
              color: "#637381",
              cursor: "pointer",
              userSelect: "none",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.color = "#111";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.color = "#637381";
            }}
            onClick={this.handleClearFilters}
          >
            Clear filters
          </div>
        </div>

        <div style={{ position: "relative", zIndex: 2 }}>
          <FiltersRow
            columns={[
              {
                key: "location",
                label: "Location",
                minWidth: 180,
                control: (
                  <PrettyDropdown2
                    key={`location-${locationOptions.length}-${resolvedLocationValue ?? 0}`}
                    options={locationOptions}
                    value={this.getDropdownValue(resolvedLocationValue)}
                    onSelectItem={this.handleLocationChange}
                  />
                ),
              },
              {
                key: "language",
                label: "Language",
                minWidth: 180,
                control: (
                  <PrettyDropdown2
                    key={`language-${languageOptions.length}-${resolvedLanguageValue ?? 0}`}
                    options={languageOptions}
                    value={this.getDropdownValue(resolvedLanguageValue)}
                    onSelectItem={this.handleLanguageChange}
                  />
                ),
              },
              {
                key: "approved",
                label: "Approved",
                minWidth: 160,
                control: (
                  <TextField
                    select
                    size="small"
                    variant="outlined"
                    value={
                      resolvedApprovedValue === true
                        ? "true"
                        : resolvedApprovedValue === false
                        ? "false"
                        : "all"
                    }
                    onChange={this.handleApprovedChange}
                    SelectProps={{
                      displayEmpty: true,
                      IconComponent: ExpandMoreIcon,
                    }}
                    sx={{
                      ...filterInputSx,
                      width: 130,
                    }}
                  >
                    <MenuItem value="all">All</MenuItem>
                    <MenuItem value="true">Approved</MenuItem>
                    <MenuItem value="false">Unapproved</MenuItem>
                  </TextField>
                ),
              },
              {
                key: "count",
                label: "Count",
                minWidth: 220,
                control: (
                  <div style={{ display: "flex", gap: 8, alignItems: "center", width: "100%" }}>
                    <TextField
                      label="Min"
                      size="small"
                      type="number"
                      variant="outlined"
                      value={filters?.filter_used_count_min ?? ""}
                      onChange={(e) =>
                        this.emitChange({
                          filter_used_count_min:
                            e.target.value === "" ? null : Number(e.target.value),
                        })
                      }
                      sx={{
                        ...filterInputSx,
                        width: 90,
                      }}
                    />
                    <TextField
                      label="Max"
                      size="small"
                      type="number"
                      variant="outlined"
                      value={filters?.filter_used_count_max ?? ""}
                      onChange={(e) =>
                        this.emitChange({
                          filter_used_count_max:
                            e.target.value === "" ? null : Number(e.target.value),
                        })
                      }
                      sx={{
                        ...filterInputSx,
                        width: 90,
                      }}
                    />
                  </div>
                ),
              },
            ]}
          />
        </div>

        <div style={{ position: "relative", zIndex: 1 }}>
          <FiltersRow
            columns={[
              {
                key: "created",
                label: "Created",
                minWidth: 340,
                control: this.renderDateRange(
                  "Created",
                  "filter_created_from",
                  "filter_created_to"
                ),
              },
              {
                key: "published",
                label: "Published",
                minWidth: 340,
                control: this.renderDateRange(
                  "Published",
                  "filter_published_from",
                  "filter_published_to"
                ),
              },
              {
                key: "last_used",
                label: "Last Used",
                minWidth: 340,
                control: this.renderDateRange(
                  "Last Used",
                  "filter_last_used_from",
                  "filter_last_used_to"
                ),
              },
            ]}
          />
        </div>
      </div>
    );
  }
}

export default CachePageFilters;